// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ls-c";
export var backButton = "_ls-4";
export var backIcon = "_ls-5";
export var chevronShortcut = "_ls-6";
export var container = "_ls-1";
export var editor = "_ls-8";
export var editorWrapper = "_ls-7";
export var prefix = "_ls-2";
export var searchIcon = "_ls-3";
export var suffix = "_ls-9";
export var suffixContent = "_ls-a";
export var suffixText = "_ls-b";
export var wrapper = "_ls-0";